import { getSrc } from "gatsby-plugin-image";
import React from "react";
import { Asset } from "../../../graphql-types";

import { useLexicon } from "../../context/LexiconContext";
import IconFacebook from "../icons/IconFacebook";
import IconPinterest from "../icons/IconPinterest";
import IconTwitter from "../icons/IconTwitter";
import ShareLinkWithPopup from "./ShareLinkWithPopup";

const getEncodedUrlWithUTMSource = (absolutePath: string, network: string) =>
  encodeURIComponent(`${absolutePath}?utm_source=${network}&utm_medium=social`);

type Props = {
  absolutePath: string;
  subtitle: string;
  img: Asset;
};

export default function SocialButtons({ absolutePath, subtitle, img }: Props) {
  const lexicon = useLexicon();

  // FIXME. Don't think this worked. Use getSrc(img) instead.
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  const media = img?.file?.localFile && getSrc(img.file.localFile);
  const encodedSubtitle = encodeURIComponent(subtitle);

  if (
    process.env.GATSBY_SITE_DOMAIN === "domestos.com" &&
    process.env.GATSBY_PATH_PREFIX === "/pl"
  ) {
    return null;
  }

  return (
    <div
      data-cy="share-icons"
      className="max-w-container mx-auto flex flex-wrap items-center justify-center pb-10 social-buttons"
    >
      {lexicon.share && <h2 className="mr-5">{lexicon.share}</h2>}
      <ShareLinkWithPopup
        network="facebook"
        href={`https://www.facebook.com/sharer/sharer.php?u=${getEncodedUrlWithUTMSource(
          absolutePath,
          "facebook"
        )}`}
        className={`mr-4 flex items-center justify-center bg-fb`}
      >
        <IconFacebook />
        <span className="sr-only">{lexicon.share}: Facebook</span>
      </ShareLinkWithPopup>
      {media && (
        <ShareLinkWithPopup
          network="pinterest"
          href={`http://www.pinterest.com/pin/create/button/?url=${getEncodedUrlWithUTMSource(
            absolutePath,
            "pinterest"
          )}&description=${encodedSubtitle}${
            media
              ? `&media=https://www.${process.env.GATSBY_SITE_DOMAIN}${media}`
              : ""
          }`}
          className={`mr-4 flex items-center justify-center bg-pinterest`}
        >
          <IconPinterest />
          <span className="sr-only">{lexicon.share}: Pinterest</span>
        </ShareLinkWithPopup>
      )}
      <ShareLinkWithPopup
        network="twitter"
        href={`https://twitter.com/intent/tweet?url=${getEncodedUrlWithUTMSource(
          absolutePath,
          "twitter"
        )}`}
        className={`mr-4 flex items-center justify-center bg-twitter`}
      >
        <IconTwitter />
        <span className="sr-only">{lexicon.share}: X</span>
      </ShareLinkWithPopup>
    </div>
  );
}
